import React, { useEffect, useState } from 'react';
import { apiHandler } from '../../api/apihandler';
import { PEOPLE_YOU_MAY_KNOW, USER_FOLLOW_REQUEST } from '../../api/constants';
import { apiSucceeded, getAvatarColor, getInitials } from '../../views/dashboard/feed/feedUtils';

const SuggestionAvatar = ({ photo, name }) => {
  if (photo) return <img src={photo} alt={name} className="nmsl-sc-avatar" />;
  return (
    <div className="nmsl-sc-avatar" style={{ background: getAvatarColor(name || 'User') }}>
      {getInitials(...(name || 'User').split(' '))}
    </div>
  );
};

// Real "People you may know" rail widget (same PEOPLE_YOU_MAY_KNOW/
// USER_FOLLOW_REQUEST calls as the People You May Know page and my-profile
// page) so the right rail on the other social screens carries live data
// instead of filler content.
const PeopleYouMayKnowWidget = ({ limit = 4 }) => {
  const [users, setUsers] = useState([]);
  const [busyIds, setBusyIds] = useState(new Set());

  useEffect(() => {
    (async () => {
      try {
        const res = await apiHandler(PEOPLE_YOU_MAY_KNOW, 'POST', { page: 1, limit });
        if (apiSucceeded(res)) setUsers(res?.data?.data?.users?.data || []);
      } catch (e) { console.error(e); }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  async function toggleFollow(userId, index, currentlyFollowing) {
    if (busyIds.has(userId)) return;
    setBusyIds((prev) => new Set([...prev, userId]));
    try {
      const res = await apiHandler(USER_FOLLOW_REQUEST, 'POST', { follower_id: userId });
      if (apiSucceeded(res)) {
        setUsers((prev) => {
          const copy = [...prev];
          copy[index] = { ...copy[index], is_following: currentlyFollowing ? 0 : 1 };
          return copy;
        });
      }
    } catch (e) { console.error(e); }
    finally {
      setBusyIds((prev) => { const next = new Set(prev); next.delete(userId); return next; });
    }
  }

  return (
    <div className="nmsl-rail-block">
      <div className="nmsl-rail-head"><h3>People you may know</h3></div>
      {users.length === 0 ? (
        <p className="nmsl-empty-note">No suggestions right now.</p>
      ) : users.map((u, index) => {
        const name = `${u?.first_name || ''} ${u?.last_name || ''}`.trim() || 'User';
        const isFollowing = u?.is_following === 1;
        return (
          <div key={u.id} className="nmsl-suggestion-card">
            <SuggestionAvatar photo={u?.user_setting?.photo} name={name} />
            <div className="nmsl-sc-text">
              <div className="nmsl-sc-name">{name}</div>
              <div className="nmsl-sc-tag">{u?.follower_count ?? 0} followers</div>
            </div>
            <button
              type="button"
              className={`nmsl-sc-follow${isFollowing ? ' following' : ''}`}
              disabled={busyIds.has(u.id)}
              onClick={() => toggleFollow(u.id, index, isFollowing)}
            >
              {isFollowing ? 'Following' : 'Follow'}
            </button>
          </div>
        );
      })}
    </div>
  );
};

export default PeopleYouMayKnowWidget;
